import React, { FC } from 'react';
import { Box } from '@mui/material';
import {
  IPartnerRequest,
  EPartnerRequestStatus,
  ERequestType,
} from 'FeatureModules/Partner/types/partner.types';
import { styled } from '@mui/material/styles';
import DismissedTitle from './DismissedTitle';
import useDialog from 'hooks/useDialog';
import CardContainer from 'DesignSystem/Layout/CardContainer/CardContainer';
import ThemeButton from 'DesignSystem/Buttons/ThemeButton/ThemeButton';
import ClickablePartnerName from './ClickablePartnerName';
import { useNavigate } from 'react-router-dom';
import { REQUEST_STATUS_CLIENT } from 'FeatureModules/Request/utils/requestStatus.utils';
import Icon from 'DesignSystem/Primitives/Icon/Icon';

interface IDeniedRequestCardProps {
  request: IPartnerRequest;
}

const Container = styled(CardContainer)(({ theme }) => ({
  background: theme.custom.themeColors.grayScale[10],
  '&:hover': {
    backgroundColor: theme.custom.themeColors.grayScale[10],
  },
}));

const DeniedRequestCard: FC<IDeniedRequestCardProps> = ({ request }) => {
  const { openDialog } = useDialog();
  const navigate = useNavigate();

  const navigateToPartner = () => {
    navigate(`/partners/${request.requestedToCompany.id}`);
  };
  const { requestTitle, requestType } = request;

  return (
    <Container
      key={request.id}
      maxWidth={300}
      minWidth={300}
      hasShadow={false}
      padding={2}
      data-testid="denied-request-card"
    >
      <Box display="flex" flexDirection="column" gap={0.5} height="100%">
        <DismissedTitle title={requestTitle} requestType={ERequestType[requestType]} />
        <Box display="flex" justifyContent="space-between" alignItems="center" mt="auto">
          <ClickablePartnerName
            partnerName={request.requestedToCompany.name}
            hasIconBackground
            onClick={navigateToPartner}
          />
          <ThemeButton
            size="medium"
            color="PRIMARY"
            startIcon={
              <Icon
                name={
                  REQUEST_STATUS_CLIENT[request.requestType][EPartnerRequestStatus.EDITED].iconName
                }
                color="white"
              />
            }
            onClick={() => openDialog({ type: 'REQUEST_DETAILS', props: { request } })}
            data-testid="view-request-details-btn"
          >
            Review
          </ThemeButton>
        </Box>
      </Box>
    </Container>
  );
};

export default DeniedRequestCard;
